import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '@pwc/appkit-react/lib/Input';

const ReadOnlyAmountFormik = ({
  value: { net, gross },
  suffix = '',
  allowGross = false,
  className = '',
  hidden = false,
}) => hidden ? null : (
  <div className={`amount-control ${className}`}>
    <Input
      type="text"
      size="sm"
      label="To Net Amount"
      suffix={suffix}
      value={net}
      disabled
    />

    {allowGross
      && <Input
        type="text"
        size="sm"
        label="To Gross Amount"
        suffix={suffix}
        value={gross}
        disabled
      />
    }

  </div>
);

ReadOnlyAmountFormik.propTypes = {
  value: PropTypes.shape({
    net: PropTypes.string.isRequired,
    gross: PropTypes.string.isRequired,
  }),
  suffix: PropTypes.string,
  allowGross: PropTypes.bool,
  className: PropTypes.string,
  hidden: PropTypes.bool,
};

export default ReadOnlyAmountFormik;
